module.exports = __webpack_public_path__ + "media/images/icon__community-9bd09706a3af38301d23e4d8f3409b04.png";